import { App, InjectionKey, Plugin, getCurrentInstance, inject, reactive } from "vue"

export type WaitInstance = {
  is: (key: string | string[]) => boolean
  start: (key: string) => void
  end: (key: string) => void
  any: () => number
  clear: () => Record<string, number>
}

declare module "@vue/runtime-core" {
  export interface ComponentCustomProperties {
    $wait: Wait
  }
}

class Wait {
  list: Record<string, number>

  constructor() {
    this.list = reactive({})
  }

  is(name: string | string[]) {
    const list = Object.keys(this.list)
    if (!Array.isArray(name)) {
      name = [name]
    }
    return list.some(item => name.find(n => item.match(new RegExp(`${n}$`))))
  }
  start(name: string) {
    return !this.list[name] && (this.list[name] = Date.now())
  }
  end(name: string) {
    const start = this.list[name]
    delete this.list[name]
    return Date.now() - start
  }
  any() {
    return Object.keys(this.list).length
  }
  clear() {
    const clearList: Record<string, number> = {}
    Object.keys(this.list).forEach(item => {
      clearList[item] = this.end(item)
    })
    return clearList
  }
}

export const wait = new Wait()
export const waitInjectionKey: InjectionKey<WaitInstance> = Symbol("wait")

const waitPlugin: Plugin = {
  install(app: App) {
    app.provide(waitInjectionKey, wait)
    app.config.globalProperties.$wait = wait
  }
}

export function useWait(): WaitInstance {
  if (!getCurrentInstance()) {
    return wait
  }

  return inject(waitInjectionKey, wait)
}

export type WaitPlugin = WaitInstance

export default waitPlugin
